/**
 * Highlights @agent mentions in text with appropriate colors
 *
 * Supports both full names and legacy short names:
 * - @ai-plant-support-engineer / @pam -> amber
 * - @ai-chemical-engineer / @aice -> blue
 * - @ai-mechanical-engineer / @max -> green
 * - @ai-electrical-engineer / @ella -> purple
 */

import React from 'react'

// Pattern to match agent mentions (case-insensitive) - supports both new and legacy formats
const MENTION_PATTERN =
  /(@ai-plant-support-engineer|@pam|@ai-chemical-engineer|@aice|@ai-mechanical-engineer|@max|@ai-electrical-engineer|@ella)/gi

// Agent color mapping
const AGENT_COLORS: Record<string, string> = {
  '@ai-plant-support-engineer': 'text-amber-500',
  '@pam': 'text-amber-500',
  '@ai-chemical-engineer': 'text-blue-500',
  '@aice': 'text-blue-500',
  '@ai-mechanical-engineer': 'text-green-500',
  '@max': 'text-green-500',
  '@ai-electrical-engineer': 'text-purple-500',
  '@ella': 'text-purple-500',
}

export function highlightAgentMentions(text: string): React.ReactNode {
  // Split text by mentions while keeping the mentions
  const parts = text.split(MENTION_PATTERN)

  if (parts.length === 1) {
    // No mentions found, return original text
    return text
  }

  return (
    <>
      {parts.map((part, index) => {
        const lowerPart = part.toLowerCase()
        const colorClass = AGENT_COLORS[lowerPart]

        if (colorClass) {
          return (
            <span key={index} className={`${colorClass} font-medium`}>
              {part}
            </span>
          )
        }

        // Regular text
        return <React.Fragment key={index}>{part}</React.Fragment>
      })}
    </>
  )
}

export default highlightAgentMentions
